const initialState = {
	popList: [],
	searchList: [],
	userList: [],
	userListKeyword: null,
	userListPage: 1,
	userIsListNext: false,
	userListTimestamp: null,
	datetime: null,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'COMMUNITY_KEYWORD_POP_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.popList = action.payload.list;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'COMMUNITY_KEYWORD_POP_LIST_INIT') {
		let newState = Object.assign({}, state);
		newState.datetime = null;
		return newState;
	}
	else if (action.type === 'COMMUNITY_KEYWORD_USER_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.userList = action.payload.list;
		newState.userListKeyword = action.payload.keyword;
		newState.userListPage = action.payload.page;
		newState.userIsListNext = action.payload.isListNext;
		newState.userListTimestamp = action.payload.timestamp;
		return newState;
	}
	else if (action.type === 'COMMUNITY_KEYWORD_USER_LIST_INIT') {
		let newState = Object.assign({}, state);
		newState.userList = [];
		newState.userListKeyword = null;
		newState.userListPage = 1;
		newState.userIsListNext = false;
		newState.userListTimestamp = null;
		return newState;
	}
	else if (action.type === 'COMMUNITY_KEYWORD_USER_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			let userList = newState.userList;
			userList = userList.filter((value) => (value.userdata_id_code !== action.payload.pic));
			newState.userList = userList;
		}
		return newState;
	}
	else if (action.type === 'COMMUNITY_KEYWORD_SEARCH_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.searchList = action.payload.list;
		return newState;
	}
	else if (action.type === 'COMMUNITY_KEYWORD_SEARCH_LIST_INIT') {
		let newState = Object.assign({}, state);
		newState.searchList = [];
		return newState;
	}
	else {
		return state;
	}
}
